import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiClock } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { PlayfulCard, PlayfulCardButton } from '@/components/custom/playful-card';
import { Badge } from '@/components/ui/badge';
import { ACTIVITY_BADGE_CLASSNAME, activityStatusVariant } from '../activityStatusVariant';
import activityIcon from '@/assets/images/icons/atividade-complementar.png';

export function ComplementaryActivityPlayfulCard({ activity }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const status = activity['activity-status-or-submitted-count'];
  const isRequired = activity['learning-system-activities']?.[0]?.is_required;
  const canAccess = status !== t('activity.activity_not_submitted');

  const classHoursLabel = activity['class-hours'] < 2 ? `${activity['class-hours']} ${t('tasks.hour')}` : `${activity['class-hours']} ${t('tasks.hours')}`;

  const openActivity = () => {
    if (!canAccess) return;
    if (status === t('activity.awaiting_submission')) {
      navigate(`/atividade-complementar/atividade/${activity.id}`);
    }
    if ([t('activity.activity_submitted'), t('activity.activity_evaluated')].includes(status)) {
      navigate(`/atividade-complementar/avaliacao/${activity.id}/${activity['activity-student-id']}`);
    }
  };

  return (
    <PlayfulCard className="p-6">
      <div className="relative mb-5 flex items-start justify-between">
        <img
          src={activityIcon}
          alt=""
          className="h-20 w-20 object-contain"
        />
        <div className="flex items-center gap-1.5">
          {isRequired && (
            <Badge
              variant="danger"
              className={ACTIVITY_BADGE_CLASSNAME}
            >
              Obrigatória
            </Badge>
          )}
          {status && (
            <Badge
              variant={activityStatusVariant(status, t)}
              className={ACTIVITY_BADGE_CLASSNAME}
            >
              {status}
            </Badge>
          )}
        </div>
      </div>

      <h3
        className="line-clamp-3 text-base font-extrabold"
        style={{ color: '#222731' }}
        title={activity.title}
      >
        {activity.title}
      </h3>

      <div className="mb-6 mt-4 flex flex-1 items-center gap-1.5 text-sm font-semibold text-neutral-500">
        <FiClock className="h-4 w-4 text-[var(--color-mission-medium)]" />
        {classHoursLabel}
      </div>

      <PlayfulCardButton
        onClick={openActivity}
        disabled={!canAccess}
      >
        {t('button.access')}
      </PlayfulCardButton>
    </PlayfulCard>
  );
}
